import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthorizationService, InitService } from '@infodata-group/inf-commons';
import { Subject } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const initService = inject(InitService);
  const authorizationService = inject(AuthorizationService);

  const emitter$ = new Subject<boolean>();
  initService.isConfigLoaded.subscribe((result) => {
    if (result) {
      initService.isLoaded$.subscribe((res) => {
        if (res) {
          emitter$.next(true);
        }
      });
      authorizationService.init();
    }
  });
  return emitter$;
};
